<template>
  <el-dialog
    :title="indicator.id ? 'Редактирование индикатор' : 'Создание индикатора'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="indicator"
      :rules="indicatorRules"
      @submit.native.prevent="saveIndicator"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="indicator.name"
          ref="indicatorToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          maxlength="10000"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6}"
          v-model="indicator.description"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveIndicator"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "indicator-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      indicator: {
        id: null,
        name: null,
        description: '',
        competence_id: null,
      },
      indicatorRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    async open(indicator) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.indicator = Object.assign({}, indicator);
      this.show = true;
      this.$nextTick(() => this.$refs.indicatorToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveIndicator() {
      if (this.indicator.id) {
        this.updateIndicator();
      } else {
        this.createIndicator();
      }
    },
    createIndicator() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.indicatorCreate({
          name: this.indicator.name,
          description: this.indicator.description,
          competence_id: this.$route.params.id,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Индикатор успешно создан'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('indicator-saved');
          })
      })
    },
    updateIndicator() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.indicatorUpdate({
          id: this.indicator.id,
          name: this.indicator.name,
          description: this.indicator.description,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Индикатор успешно обновлен'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('indicator-saved');
          })
      })
    }
  }
}
</script>

<style scoped>

</style>